import { createSlice } from "@reduxjs/toolkit";
import patientMicroscopicData from '@custom/rtk-apis/microscopy/getPatientMicroscopicLink'

const initialState = {
  status:"",
  result:[],
  message:"",
  loading:false,
  error:""
};

const patientMicroscopicDataSlice = createSlice({
  name: "patientMicroscopicData",
  initialState,
  reducers: {
    resetStatus (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(patientMicroscopicData.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(patientMicroscopicData.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(patientMicroscopicData.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default patientMicroscopicDataSlice.reducer;
export const { resetStatus } = patientMicroscopicDataSlice.actions;
